var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MenuItemBaseComponent } from './../../../../common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component';
var MenuItemComponent = /** @class */ (function (_super) {
    __extends(MenuItemComponent, _super);
    function MenuItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuItemComponent.prototype.isItemLinkActive = function (item, children) {
        var _this = this;
        if (item.link === this.currentRoute)
            return true;
        else if (this.currentRoute.includes(item.link) && item.link !== '/')
            return true;
        // TODO: should find a better way
        if (this.currentRoute.includes('/romanescu-lifestyle/') &&
            item.link === '/romanescu-lifestyle/concept')
            return true;
        if (children.length > 0)
            if (children.find(function (child) { return _this.currentRoute.includes(child.link); }))
                return true;
        return false;
    };
    return MenuItemComponent;
}(MenuItemBaseComponent));
export { MenuItemComponent };



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-item/menu-item.component.ts.pre-build-optimizer.js